import { render, staticRenderFns } from "./Component5.vue?vue&type=template&id=278825d6&scoped=true&"
import script from "./Component5.vue?vue&type=script&lang=js&"
export * from "./Component5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278825d6",
  null
  
)

export default component.exports